// extracted by mini-css-extract-plugin
module.exports = {"slidecontainer":"IrisSlider_slidecontainer__3QJPN","slider":"IrisSlider_slider__3sEha"};